/**
 * Auto-generated from dark-roast/api-envoy OpenAPI spec. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { z } from 'zod';
import { type AccountEntity, accountSchema } from '@axiom/domain';
import { CountryCode } from '../../../enums/generated/country-code';
import { Industry } from '../../../enums/generated/industry';
import { eSAccountContactDAOSchema } from './es-account-contact-dao';
import { eSUserDAOSchema } from './es-user-dao';

export const eSAccountDAOSchema = accountSchema.pick({ "displayName": true, "id": true, "integrationId": true, "lawyerOnStaff": true, "name": true, "ownerUserId": true, "salesforceId": true }).extend({ "accountType": z.enum(["Direct"]).nullish(), "calculatedConfidentialName": z.string().nullish(), "calculatedName": z.string().nullish(), "contacts": z.array(z.lazy(() => eSAccountContactDAOSchema)), "industryValue": z.nativeEnum(Industry).nullish(), "ownerUser": z.lazy(() => eSUserDAOSchema).nullish(), "region": z.nativeEnum(CountryCode).nullish() });
export type ESAccountDAO = Pick<AccountEntity, "displayName" | "id" | "integrationId" | "lawyerOnStaff" | "name" | "ownerUserId" | "salesforceId"> & z.infer<typeof eSAccountDAOSchema>;
